import colors from '@magoosh/lib/styles/colors.module.scss';

import { isIELTSExamName } from '@test_prep/app/pages/analytics/exam_name_utils';

export default (examName: string, sections: string) => {
  if (examName === 'GMAT') {
    if (!sections || sections === 'all') {
      return [
        { color: colors.gray85, label: 'Math Mastered', value: 40 }
      ];
    }

    let result = [];

    if (sections.indexOf('quantitative_reasoning') !== -1){
      result.push({ color: colors.gray85, label: 'Math Mastered', value: 40 });
    }

    return result;
  } else if (examName === 'GRE') {
    if (!sections || sections === 'all') {
      return [
        { color: colors.gray85, label: 'Math Mastered', value: 40 },
        { color: colors.grayLighter, label: 'Vocab Mastered', value: 30 }
      ];
    }

    let result = [];

    if (sections.indexOf('math') !== -1){
      result.push({ color: colors.gray85, label: 'Math Mastered', value: 40 });
    }
    if (sections.indexOf('verbal') !== -1) {
      result.push({ color: colors.grayLighter, label: 'Vocab Mastered', value: 30 });
    }

    return result;
  } else if (examName === 'SAT') {
    if (!sections || sections === 'all') {
      return [
        { color: colors.grayLighter, label: 'Reading & Writing Mastered', value: 30 },
        { color: colors.gray85, label: 'Math Mastered', value: 40 }
      ];
    }

    let result = [];

    if (sections.indexOf('reading_and_writing') !== -1) {
      result.push({ color: colors.grayLighter, label: 'Reading & Writing Mastered', value: 30 });
    }
    if (sections.indexOf('math') !== -1){
      result.push({ color: colors.gray85, label: 'Math Mastered', value: 40 });
    }

    return result;
  } else if (examName === 'TOEFL' || isIELTSExamName(examName)) {
    return [
      { color: colors.grayLighter, label: 'Vocab Mastered', value: 30 }
    ];
  } else {
    return [];
  }
};
